import { ref, uploadBytes, getDownloadURL, deleteObject, getBytes } from 'firebase/storage';
import { storage } from '../firebase';

// תמונות שהועלו ע"י המשתמש מקבלות שם בפורמט: timestamp-randomid-filename
// תמונות מתבניות לא יגיעו בפורמט הזה - ולכן לא נמחק אותן מ-Storage
const isUserOwnedImage = (imageUrl) => {
  if (!imageUrl) return false;
  const urlPath = decodeURIComponent(imageUrl.split('/o/')[1]?.split('?')[0] || '');
  const filename = urlPath.split('/').pop() || '';
  return /^\d{13}-[a-z0-9]{7}-/.test(filename);
};

export const StorageService = {
  async uploadImage(file, folder = 'images') {
    const uniqueId = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const fileName = `${folder}/${uniqueId}-${file.name}`;
    const storageRef = ref(storage, fileName);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  },

  async uploadDocument(file, folder = 'documents') {
    const uniqueId = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const fileName = `${folder}/${uniqueId}-${file.name}`;
    const storageRef = ref(storage, fileName);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  },

  /**
   * Downloads a document from Firebase Storage as ArrayBuffer.
   * Uses Firebase SDK directly — bypasses CORS issues that occur with fetch().
   */
  async downloadDocumentBytes(documentUrl) {
    // Extract the storage path from the download URL
    const urlPath = decodeURIComponent(documentUrl.split('/o/')[1]?.split('?')[0] || '');
    const storageRef = ref(storage, urlPath);
    const bytes = await getBytes(storageRef);
    return bytes;
  },

  async deleteImage(imageUrl) {
    if (!isUserOwnedImage(imageUrl)) return;
    const fileRef = ref(storage, imageUrl);
    await deleteObject(fileRef);
  }
};
